import React from 'react';
import VideoLinkPageTemplate from './VideoLinkPageTemplate';
import ProjectDetails from './ProjectDetails';
import ToWhomILetGoStill from '../assets/images/ToWhomILetGoStill.jpg';

function Breathe() {
  const title = "TO WHOM I LET GO (2026)";
  const subtitle = "Short Film, 12 mins";
  const description = "In the quiet streets of Siena, a young man confronts the weight of his past and the silence he’s built around himself, forcing him to face a truth he’s long avoided.";
  const imageSrc = ToWhomILetGoStill;

  const credits = [
    { role: "Writer, Director, Editor", name: "KENNETH NGUYEN" },
    { role: "Music", name: "VINCENT NGUYEN" },
  ];

  const keycast = [
    { role: "Damien", name: "JAMMEL YEBOAH" },
    { role: "Suz", name: "CLAIRE LEE (voice)" },
  ];

  const festivals = [
    { name: "Virginia Film Festival 2026", note: "Official Selection" },
    { name: "Alexandria Film Festival 2026", note: "Official Selection" },
    { name: "Charlottesville Indie Film Festival 2026", note: "Official Selection" },
    { name: "Virginia Student Film Festival 2026", note: "Official Selection" },
    { name: "Richmond Film Network 2025", note: "Official Selection" }
  ];

  return (
    <div>
      <VideoLinkPageTemplate
        title={title}
        subtitle={subtitle}
        description={description}
        imageSrc={imageSrc} // Pass the image source instead of the video.
      />
      
      <ProjectDetails festivals={festivals} credits={credits} cast={keycast} />

    </div>
  );
}

export default Breathe;
